import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/app/contexts/AuthContext";
import { ROUTES } from "@/app/config/routes";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
